export default "__VITE_ASSET__2hBmVnAm__"